"use client";

import type { ShopSummary } from "@jurni/schemas";
import { useEffect } from "react";
import { identifyMerchantShop } from "@/lib/analytics/client";

export function PosthogShopGroup({
  shop,
}: {
  shop: Pick<ShopSummary, "id" | "name" | "domain">;
}) {
  const { id, name, domain } = shop;
  // The outer identity provider establishes the authenticated scope in a layout effect.
  useEffect(() => {
    identifyMerchantShop({ id, name, domain });
  }, [id, name, domain]);
  return null;
}
